import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {IntroWizardServiceProvider} from "../intro-wizard-service/intro-wizard-service";
import {User, UserStateProvider} from "../user-state/user-state";
import {ApiCourseDataProvider} from "../api-course-data/api-course-data";
import {UserStatsProvider} from "../user-stats/user-stats";
import {ChatClientProvider} from "../chat-client/chat-client";
import {LocalStorageWrapper} from "../local-storage-wrapper/local-storage-wrapper";

export class UserResponse {
  data: User;
  token: string;
  refresh_token: string
}
/*
  Generated class for the ApiAuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiAuthProvider {

  constructor(public api: ApiProvider, public introWizard: IntroWizardServiceProvider, public userState: UserStateProvider, public courseData: ApiCourseDataProvider, public stats: UserStatsProvider, public chatClient: ChatClientProvider, public localStorage: LocalStorageWrapper) {
  }

  login(username: String, password: String) {
    let me = this;
    return new Promise<UserStateProvider>((resolve, reject) => {
      me.api.callPost('/login_check', {username, password})
        .subscribe((res: any) => {
          console.log(res);
          me.userState.user = res.data;
          me.userState.token = res.token;
          this.localStorage.setItem('api_token', res.token);
          this.localStorage.setItem('api_user_id', res.data.id);
          this.localStorage.setItem('api_refresh', res.refresh_token);
          me.introWizard.clear();
          resolve(me.userState);
        }, (err) => {
          reject({
            errorMessage: err
          });
        });
    });
  }

  logout() {
    var me = this;
    this.courseData.resetData();
    return new Promise<UserStateProvider>((resolve, reject) => {
      try {
        this.chatClient.close();
      } catch(e) {

      }
      this.localStorage.removeItem('api_token');
      this.localStorage.removeItem('api_token');
      this.localStorage.removeItem('api_user_id');
      this.localStorage.removeItem('api_refresh');
      me.userState.token = null;
      me.userState.user = null;
      me.introWizard.clear();
      me.stats.clearCache();
      this.localStorage.removeAll().then(() => {
        resolve();
      });
    });

  }

  register() {
    let me = this;
    return new Promise((resolve, reject) => {
      me.api.callPost('/users', (me.introWizard.getData()))
        .subscribe((res: any)=> {
          me.login(me.introWizard.email, me.introWizard.password).then(res => {
            resolve();
          }, err => {
            reject({
              errorMessage: err.errorMessage
            })
          });
        }, (err) => {
          reject({
            errorMessage: err.error['detail']
          });
        });
    });
  }

  passwordUpdate(oldPassword: string, newPassword: string) {
    let me = this;
    return new Promise((resolve, reject) => {
      me.api.callPost('/users/'+this.localStorage.getItem('api_user_id')+'/passwordUpdate', {oldPassword: oldPassword, newPassword: newPassword})
        .subscribe((res: any)=> {
          resolve();
        }, (err) => {
          console.log('password update ',err);
          reject();
        });
    });
  }

  validateInsuranceNumber(insuranceId: String) {
    let me = this;
    return new Promise<boolean>((resolve, reject) => {
      me.api.callGet<boolean>('/validateInsurance', {insurance: insuranceId})
        .subscribe((res: boolean) => {
          resolve(res);
        }, (err) => {
          reject(false);
        });
    });

  }

  tryToRefreshSession() {
    var me = this;
    console.log('try ot refresh session')
    return new Promise<UserStateProvider>((resolve, reject) => {
      if(!this.localStorage.getItem('api_token') || !this.localStorage.getItem('api_user_id') || this.localStorage.getItem('api_user_id')=="null") {
        return reject();
      }
      me.api.callGet<User>('/users/'+this.localStorage.getItem('api_user_id')).subscribe(res => {
        console.log('refreshing success');
        me.userState.user = res;
        resolve(me.userState);
      }, err => {
        console.log('session refresh error', err);
        reject();
      })
    });
  }

  checkDelete() {
    let me = this;
    return new Promise((resolve, reject) => {
      me.api.callGet('/users/'+this.localStorage.getItem('api_user_id')+'/delete', {})
        .subscribe((res: any)=> {
          resolve(res);
        }, (err) => {
          console.log('deletion ',err);
          reject();
        });
    });
  }

  delete() {
    let me = this;
    return new Promise((resolve, reject) => {
      me.api.callPost('/users/'+this.localStorage.getItem('api_user_id')+'/delete', {})
        .subscribe((res: any)=> {
          resolve();
        }, (err) => {
          console.log('deletion ',err);
          reject();
        });
    });
  }

  passwordForgottenRequest(email: string) {
    let me = this;
    return new Promise<boolean>((resolve, reject) => {
      me.api.callPost<boolean>('/passwordReset', {email: email})
        .subscribe((res: any) => {
          resolve(res.status);
        }, (err) => {
          reject(false);
        });
    });
  }

  passwordForgottenUpdate(token: any, password: string) {
    let me = this;
    return new Promise<boolean>((resolve, reject) => {
      me.api.callPost<boolean>('/passwordResetUpdate', {token: token, password: password})
          .subscribe((res: any) => {
            resolve(res.status);
          }, (err) => {
            reject(false);
          });
    });

  }
}



// WEBPACK FOOTER //
// ./src/providers/api-auth/api-auth.ts